import type { ChartContext } from "./context";

export function buildBoxPlotOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, translateNode, palette, ct, base } = context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const vals = ds.values as unknown as Array<Record<string, unknown>>;
  const labels = vals.map((v) => v.x as string);
  return {
    ...base,
    tooltip: {
      trigger: "axis",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (points: Array<{ value: number[]; dataIndex: number }>) => {
        const point = points[0];
        if (!point) return "";
        const values = point.value.slice(-5);
        return `${translateNode(labels[point.dataIndex] ?? "")}\n${[
          "Minimum",
          "Lower quartile",
          "Median",
          "Upper quartile",
          "Maximum",
        ]
          .map((label, index) => `${translateNode(label)}: ${values[index]}`)
          .join("\n")}`;
      },
    },
    xAxis: {
      type: "category",
      data: labels,
      axisLabel: { color: ct.secondary, formatter: translateNode },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: ct.secondary },
      splitLine: { lineStyle: { color: ct.lightBorder } },
    },
    grid: { left: 60, right: 20, bottom: 40, top: 65, containLabel: true },
    series: [
      {
        type: "boxplot",
        name: ds.label,
        data: vals.map((v) => v.y as number[]),
        itemStyle: { color: palette[0] },
      },
    ],
  };
}
